// Auth page loaders - login, register, verification, and account management
// These wrapper functions import and execute the actual loaders

export const verifyEmailLoader = async (args: any) => {
    const module = await import("../pages/auth/VerifyEmail");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const activateAccountLoader = async (args: any) => {
    const module = await import("../pages/auth/ActivateAccount");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const activateParentAccountLoader = async (args: any) => {
    const module = await import("../pages/auth/ActivateParentAccount");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const grantKedAccessToStudentLoader = async (args: any) => {
    const module = await import("../pages/auth/GrantProductAccessToStudentPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const cancelNewsletterLoader = async (args: any) => {
    const module = await import("../components/user/newsletter/CancelNewsletter");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const enCancelNewsletterLoader = async (args: any) => {
    const module = await import("../components/user/newsletter/EnCancelNewsletter");
    return module.loader ? await (module.loader as any)(args) : null;
};